import {
  getReturnType as returnType,
  IMaintenanceReturnResult,
  IResultEntity,
  isCampaignReturn,
  isMaintenanceReturn,
  isSalesReturn,
  ReturnType,
  ISalesReturnResult,
  ICampaignReturnResult,
} from "@iloq/shared/";

export const productReturnDataMixin = {
  methods: {
    getReturnType(
      data: IResultEntity | ISalesReturnResult | ICampaignReturnResult | IMaintenanceReturnResult
    ): string | undefined {
      const returnTypeForMaintenanceReturn = (data as any).returnType;
      if (returnTypeForMaintenanceReturn) {
        return returnTypeForMaintenanceReturn;
      }
      return (data as IResultEntity).productReturnData?.returnType;
    },
    isSalesReturn(
      data: IResultEntity | ISalesReturnResult | ICampaignReturnResult | IMaintenanceReturnResult
    ): boolean {
      return returnType(data) === ReturnType.SALES_RETURN;
    },
    isCampaignReturn(
      data: IResultEntity | ISalesReturnResult | ICampaignReturnResult | IMaintenanceReturnResult
    ): boolean {
      return returnType(data) === ReturnType.CAMPAIGN_RETURN;
    },
    isMaintenanceReturn(
      data: IResultEntity | ISalesReturnResult | ICampaignReturnResult | IMaintenanceReturnResult
    ): boolean {
      return returnType(data) === ReturnType.MAINTENANCE_RETURN;
    },
  },
};

export const formMixin = {
  methods: {
    formTypeIsNone(): boolean {
      return (this as any).form?.returnType === ReturnType.NONE;
    },
    formTypeIsMaintenanceReturn(): boolean {
      return isMaintenanceReturn((this as any).form?.returnType);
    },
    formTypeIsSalesReturn(): boolean {
      return isSalesReturn((this as any).form?.returnType);
    },
    formTypeIsCampaignReturn(): boolean {
      return isCampaignReturn((this as any).form?.returnType);
    },
  },
};

export const inputMixin = {
  methods: {
    inputIsInvalid(inputName: string): boolean {
      return (this as any).getFieldClasses(inputName)?.["is-invalid"] === true;
    },
  },
};
